import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

import TextInput, { TextInputProps } from './TextInput'

type TextInputControllerProps<T extends FieldValues> = UseControllerProps<T> & {
  fullWidth?: boolean
  label?: React.ReactNode
  required?: boolean
  TextInputProps?: Omit<TextInputProps, 'fullWidth' | 'label' | 'required'>
  readOnly?: boolean
}
export default function TextInputController<T extends FieldValues>(props: TextInputControllerProps<T>) {
  const { control, fullWidth = false, label, name, required = false, TextInputProps = {}, readOnly = false } = props
  const {
    field,
    fieldState: { error },
  } = useController({ name, control })

  return (
    <TextInput
      {...TextInputProps}
      error={!!error}
      fullWidth={fullWidth}
      helperText={error?.message}
      inputRef={field.ref} // send input ref, so we can focus on input when error appear
      label={label}
      name={field.name} // send down the input name
      onChange={field.onChange} // send value to hook form
      onBlur={field.onBlur} // notify when input is touched/blur
      readOnly={readOnly}
      required={required}
      value={field.value} // input value
    />
  )
}
